import {NgModule} from '@angular/core'
import {RouterModule, Routes} from '@angular/router'
import { AdminAuthorized } from './core/guards/admin-authorized.guard'

import {UserAlreadyLogged} from './core/guards/user-already-logged.guard'
import {UserAuthorized} from './core/guards/user-authorized.guard'
import { MirrorPoliciesGuard } from './core/guards/mirror-policies.guard'
import { OonEnabledGuard } from './core/guards/oon-enabled.guard'


const routes: Routes = [
    {
        path: 'auth',
        loadChildren: async () =>
            await import('./features/auth/auth.module').then((m) => m.AuthModule),
        canActivate: [UserAlreadyLogged],
        data: {
            headerConfig :  {
                headerTitle: 'Dashboard',
                ctaHeaderLabel: 'Relatórios'
            }
        }

    },
        {
        path: 'dashboard-inicial',
        loadChildren: async () =>
            await import('./features/dashboard-inicial/dashboard-inicial.module').then(
                (m) => m.DashboardInicialModule
            ),
        canActivate: [UserAuthorized],
        data: {
            pageTitle: 'Dashboard Inicial'
        }
    },
    {
        path: 'customers',
        loadChildren: async () =>
            await import('./features/customer/customer.module').then(
                (m) => m.CustomerModule
            ),
        canActivate: [UserAuthorized]
    },

    
    
    {
        path: 'vehicles',
        loadChildren: async () =>
            await import('./features/vehicle/vehicle.module').then((m) => m.VehicleModule),
        canActivate: [UserAuthorized]
    },
    
            {
        path: 'profile',
        loadChildren: async () =>
            await import('./features/user/user.module').then(
                (m) => m.UserModule
            ),
        canActivate: [UserAuthorized]
    },
    {
        path: 'users-management',
        loadChildren: async () =>
            await import('./features/users-management/users-management.module').then(
                (m) => m.UsersManagementModule
            ),
        canActivate: [UserAuthorized]
    },
    {
        path: 'admin',
        loadChildren: async () =>
            await import('./features/admin/admin.module').then(
                (m) => m.AdminModule
            ),
        canActivate: [AdminAuthorized]
    },
    {
        path: 'documentos',
        loadChildren: async () =>
            await import('./features/admin/system-documents-list/system-documents-list.module').then(
                (m) => m.SystemDocumentsListModule
            ),
        canActivate: [UserAuthorized]
    },
        {
        path: 'oon-policies',
        loadChildren: async () =>
            await import('./features/oon-policies/oon-policies.module').then(
                (m) => m.OonPoliciesModule
            ),
        canActivate: [UserAuthorized, OonEnabledGuard]
    },
    {
        path: 'oon-sinisters',
        loadChildren: async () =>
            await import('./features/oon-sinisters/oon-sinisters.module').then(
                (m) => m.OonSinistersModule
            ),
        canActivate: [UserAuthorized, OonEnabledGuard]
    },
    {
        path: 'mirror-policies',
        loadChildren: async () =>
            await import('./features/mirror-policies/mirror-policies.module').then(
                (m) => m.MirrorPoliciesModule
            ),
        canActivate: [UserAuthorized, MirrorPoliciesGuard]
    },
                    
    
                {
        path: 'external',
        loadChildren: async () =>
            await import('./features/external-links/external-links.module').then(
                (m) => m.ExternalLinksModule
            )
    },
    {
        path: 'products',
        loadChildren: async () =>
            await import('./features/product/product.module').then(
                (m) => m.ProductModule
            )
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard-inicial'
    },

    {
        path: '**',
        redirectTo: ''
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
